// Side effect module: imported first by the app entry so the member token cookies are
// gone before any other module is evaluated or any request is sent. A no-op unless the
// build was made with VITE_PURGE_MBR_TOKEN=true.
import { purgeMbrTokenCookies } from './share/utils/mbr-token-purge';

purgeMbrTokenCookies();
